import semver from 'semver';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import {
  ParentTask,
  Task,
  CommonListResponse,
  TaskParams,
  TaskGroupParams,
  PaginationResult,
  TaskGroup,
  TaskOverview,
  TaskScene,
  YLRecommendPriorityEnum,
  ChangeStatus,
  ApplyChangeType,
  ChangeListItem,
  RecommendArtist,
  ActivityTask,
} from 'common/types';
import { UserRoleType } from 'common/constants';

const tasks = {
  // 获取所有需求组
  getTaskGroups: async (params: TaskGroupParams) => {
    const {
      data: { items, total },
    } = await FastApiAxiosInstance.get<PaginationResult<TaskGroup>>('/api/v1/task/getTaskGroups', { params });
    return { items, total } as { items: TaskGroup[]; total: number };
  },
  // 新版getTasks
  getTasksNew: async (params: TaskParams) => {
    const {
      data: { items, total },
    } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v2/task/getTasks', { params });
    return { items, total } as { items: ParentTask[]; total: number };
  },
  //新版获取任务overview
  getTaskNumOverviewNew: async (role, projectId?: number) => {
    const params = { role };
    !!projectId && Object.assign(params, { projectId });
    const { data } = await FastApiAxiosInstance.get<TaskOverview[]>('/api/v2/task/getTaskNumOverview', { params });
    return data;
  },
  // 新版获取任务详情
  getParentTaskInfo: async (params: {
    parentTaskId: number | string;
    // biddenId?: number;
    role?: UserRoleType;
  }) => {
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v2/task/getParentTaskInfo', {
      params,
    });
    return data;
  },
  // 子任务的需求信息面板的展示数据
  getTaskInfo: async ({ taskId, ignoreErrorMsg }: { taskId: number; ignoreErrorMsg?: boolean }): Promise<Task> => {
    const params = { taskId };
    const { data } = await FastApiAxiosInstance.get('/api/v1/task/getTaskInfo', { params });
    const { taskTemplate: originTaskTemplate } = data || {};
    let taskTemplateObj;
    if (originTaskTemplate) {
      try {
        taskTemplateObj = JSON.parse(originTaskTemplate);
      } catch (e) {}
    }
    return { ...data, taskTemplateObj };
  },

  getTaskVersion: async ({ parentTaskId, taskId }: { parentTaskId?: number; taskId?: number }) => {
    if (!parentTaskId && !taskId) {
      return;
    }
    const params = {};
    taskId && Object.assign(params, { taskId: Number(taskId) });
    parentTaskId && Object.assign(params, { parentTaskId: Number(parentTaskId) });
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/task/getTaskVersion', { params });
    let isVersion0_3_x = false;
    try {
      isVersion0_3_x = semver.gt(data.version, '0.2.3');
    } catch (e) {}
    return isVersion0_3_x;
  },
  getUserByParentTask: (params: { parentTaskId: number; query?: string ;signal?: AbortSignal}) => {
    return FastApiAxiosInstance.get<CommonListResponse<RecommendArtist>>('/api/v1/user/getUserByTask', { params });
  },

  //发起需求变更
  submitTaskChange: (params: {
    parentTaskId: number;
    targetUserId: number;
    applyType: ApplyChangeType; // 0时间，1金钱
    applyValue: string;
    applyReason: string;
    reimbursementName?: string;
  }) => {
    return FastApiAxiosInstance.post<null>('/api/v1/task/change/submit', params);
  },

  // 同意/拒绝变更
  processChange: (params: { changeApplyId: number; status: ChangeStatus }) => {
    return FastApiAxiosInstance.post<null>('/api/v1/task/change/update', params);
  },

  //撤销变更
  revokeChange: (params: { changeApplyId: number }) => {
    return FastApiAxiosInstance.post<null>('/api/v1/task/change/revoke', params);
  },

  //申请变更列表
  getChangeList: (params: { parentTaskId?: number; role?: UserRoleType }) => {
    return FastApiAxiosInstance.get<CommonListResponse<ChangeListItem>>('/api/v1/task/change/list', { params });
  },

  //变更有灵推荐优先级
  markRecommendPriority: (params: { biddenId: number; priority: YLRecommendPriorityEnum }) => {
    return FastApiAxiosInstance.post<null>('/api/v1/bid/markRecommendPriority', params);
  },

  checkDemandStatus: (params: { parentTaskId: number }) => {
    return FastApiAxiosInstance.post<{ allowRecommend: boolean }>('/api/v1/backend/checkDemandStatus', params);
  },

  // 获取需求场景，包含场景下的类型
  getTaskSceneList: () => {
    return FastApiAxiosInstance.get<{ total: number; items: TaskScene[] }>('/api/v2/task/requirement/scene');
  },

  // 查询活动任务列表
  getActivityTasks: async (params: TaskParams) => {
    const {
      data: { items, total },
    } = await FastApiAxiosInstance.get<any, ExtendAxioResponse<{ items: ActivityTask[]; total: number }>>(
      '/api/v1/task/getActivityTasks',
      { params },
    );
    return { items, total };
  },
  //新版获取任务overview
  getActivityTaskNumOverview: async (role, projectId?: number) => {
    const params = { role };
    !!projectId && Object.assign(params, { projectId });
    const { data } = await FastApiAxiosInstance.get<TaskOverview[]>('/api/v1/task/getActivityNumOverview', {
      params,
    });
    return data;
  },
};
export default tasks;
